import { signOut } from "aws-amplify/auth";
import { HERO_INFO, QUIZ_INFO, TOKEN } from "shared/constants/StorageConsts";
import { saveQuiz } from "shared/service/StrmService";
import * as Sentry from "@sentry/react";
import { getRefPageLocalStorage } from "./ref-page";

export const autenticado = () => {
  return localStorage.getItem(TOKEN) != null;
};

export const saveReturnURL = (returnUrl?: string) => {
  const url = returnUrl || window.location.pathname;
  const urlListToIgnore = ["/login"];

  if (!urlListToIgnore.includes(url)) {
    sessionStorage.setItem("returnURL", url);
  } else {
    console.log("ignorado URL:", url);
  }
};

export const logout = async (keepSession: boolean = true) => {
  try {
    await signOut({ global: true });
  } finally {
    if (keepSession) {
      saveReturnURL();
    }

    localStorage.clear();
    window.location.href = "/login";
  }
};

export const hasClaim = (claim: string, loggedUser: any) => {
  return loggedUser?.claims
    ?.map((cl: string) => cl.toUpperCase())
    .includes(claim.toUpperCase());
};

export const hasQuizPending = () => {
  return sessionStorage.getItem(QUIZ_INFO) !== null;
};

export const hasHeroPending = () => {
  return sessionStorage.getItem(HERO_INFO) !== null;
};

export const handlePendingQuiz = async (callback: any) => {
  if (hasQuizPending()) {
    const quiz = JSON.parse(sessionStorage.getItem(QUIZ_INFO) || "{}");
    try {
      if (await saveQuiz(quiz)) {
        sessionStorage.removeItem(QUIZ_INFO);
        callback(true);
      } else {
        callback();
      }
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setTransactionName("Fluxo login quiz");
        scope.setTag("campanha", getRefPageLocalStorage());
        scope.setLevel("fatal");
        scope.setExtras({
          quiz,
        });
        Sentry.captureException(error);
        throw error;
      });
    }
    return true;
  } else {
    return false;
  }
};

export const handlePendingHero = async (callback: any) => {
  if (hasHeroPending()) {
    const hero = JSON.parse(sessionStorage.getItem(HERO_INFO) || "{}");
    try {
      if (await saveQuiz(hero)) {
        sessionStorage.removeItem(HERO_INFO);
        callback(true);
      } else {
        callback();
      }
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setTransactionName("Fluxo login hero");
        scope.setTag("campanha", getRefPageLocalStorage());
        scope.setLevel("fatal");
        scope.setExtras({
          hero,
        });
        Sentry.captureException(error);
        throw error;
      });
    }
    return true;
  } else {
    return false;
  }
};
